import navigation from "@areas/Core/Views/Shared/Partials/js/xyl.views.navigation";
import countrySelector from "@areas/Core/Views/Shared/Partials/js/xyl.views.countryselector.js";
import countryPrompt from "@areas/Core/Views/Shared/Partials/js/countryPrompt.module.js";
import imageOverview from "@areas/CommerceCatalog/Views/Shared/Partials/js/imageOverview.module";
import performanceCurves from "@areas/CommerceCatalog/Views/Shared/Partials/js/performanceCurves.module";
import techSpecTables from "@areas/Core/Views/Shared/Partials/js/techSpecTable.js";
import productTechnicalDrawings from "@areas/CommerceCatalog/Views/Shared/Partials/js/productTechnicalDrawings.module";
import sensusDocuments from "@client/components/Documents/sensusDocuments.js";
import type { XylView } from "../../helpers/xyl-view-helpers";

export const partials: XylView[] = [
	navigation,
	countrySelector,
	countryPrompt,
	imageOverview,
	performanceCurves,
	techSpecTables,
	productTechnicalDrawings,
	sensusDocuments,
];
